module.exports = __webpack_public_path__ + "img/preview_doc.5fc18568.svg";